import { memo } from "react";
import { Box } from "@mui/material";
import { IDashboardSummary } from "../../../interfaces/dashboard";
import { formatNumber, formatRate } from "../../../utils/metricsFormatters";
import KpiCard from "../KpiCard";

interface IExecutiveSummaryProps {
  data: IDashboardSummary;
}

// Figma: 8 KpiCard iguales en una sola fila en desktop. Se usa CSS grid (no
// MUI <Grid>) porque 8 columnas no dividen limpio el sistema de 12 de Grid v1.
const GRID_SX = {
  display: "grid",
  gap: 2,
  gridTemplateColumns: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(4, 1fr)",
    lg: "repeat(8, 1fr)",
  },
};

const ExecutiveSummary = ({ data }: IExecutiveSummaryProps) => {
  // % Cumplimiento SLA es el complemento directo de slaBreachedRate (ya
  // calculado por el backend): breached% + compliant% = 100%.
  const slaComplianceRate = 100 - data.slaBreachedRate;

  return (
    <Box sx={GRID_SX}>
      {/* Sin comparativas vs. período anterior (deltas): omitidas por
          definición de producto. */}
      <KpiCard title="Total de envíos" value={formatNumber(data.totalOrders)} />
      <KpiCard title="Entregados" value={formatNumber(data.deliveredCount)} />
      {/*
        TODO(backend): "No entregados" (Figma) requiere un campo dedicado en
        IDashboardSummary (distinto de canceledCount) que represente envíos
        aún no entregados y no cancelados. No se deriva de totalOrders -
        deliveredCount porque esa resta incluiría cancelados, lo cual no
        coincide con el "No entregados" del diseño (categoría separada de
        "Cancelados" con su propio valor). Se deja el placeholder listo para
        el dato cuando exista.
      */}
      <KpiCard title="No entregados" value="—" />
      <KpiCard title="Cancelados" value={formatNumber(data.canceledCount)} />
      {/*
        TODO(backend): "Devoluciones" (Figma) no tiene campo en
        IDashboardSummary (no hay returnedCount). Placeholder preparado para
        el dato cuando el backend lo exponga.
      */}
      <KpiCard title="Devoluciones" value="—" />
      {/*
        TODO(backend): el delta (vs. período anterior) de estas dos tasas no
        se puede calcular hoy: IDashboardSummary no tiene
        deliveredRatePrev/slaBreachedRatePrev, solo los *_Prev de conteos
        absolutos. Se muestra el valor actual sin badge de variación hasta
        que el backend agregue esos campos.
      */}
      <KpiCard title="% Entregas exitosas" value={formatRate(data.deliveredRate)} />
      <KpiCard title="% Cumplimiento SLA" value={formatRate(slaComplianceRate)} />
      <KpiCard
        title="Operadores activos"
        value={formatNumber(data.activeOperators)}
      />
    </Box>
  );
};

export default memo(ExecutiveSummary);
